// Admin Constants - Main entry point
// Import from "@/constants/admin" for all admin-related constants
//
// ⚠️ Public routes (e.g. api/frontend.ts) must NOT import this barrel: it re-exports
// SECTION_VARIANTS, which statically imports every admin Form_* (editors, TipTap, etc.).
// Import from `@/constants/admin/sectionTypes` or `./common` instead when you only need ids.

// Common constants
export { FIELD_NAMES, ACTION_TYPES, DEFAULT_SELECT_VALUE, DEFAULT_NONE_OPTION } from "./common"

// Core constants
export {
  UNIVERSITY_ID,
  SECTION_TYPES,
  UNIVERSITY_SETTINGS_SECTION_TYPES,
  LEAD_DROP_POPUP_VARIANTS,
  LEAD_DROP_FORM_VARIANTS,
  COURSES_VARIANTS,
  HIGHER_QUALIFICATION_VARIANTS,
  UNIVERSITY_VARIANTS,
  PAGE_TYPES,
} from "./sectionTypes";

// Section Variants Configuration
export { SECTION_VARIANTS, getVariantDetails } from "./sectionVariants";

// Section Metadata
export { SECTION_METADATA } from "./sectionMetadata";

// University Settings
export {
  // Setting key constants
  SETTING_KEYS,
  // Variant configs
  LEAD_DROP_POPUP_VARIANTS_CONFIG,
  LEAD_DROP_FORM_VARIANTS_CONFIG,
  COURSES_VARIANTS_CONFIG,
  HIGHER_QUALIFICATION_VARIANTS_CONFIG,
  UNIVERSITY_VARIANTS_CONFIG,
  // Unified settings config
  UNIVERSITY_SETTINGS_CONFIG,
  getUniversitySettingConfig,
  getAllUniversitySettingConfigs,
  getVariantDetails as getUniversityVariantDetailsById,
  // Legacy helpers
  getLeadDropPopupVariantDetails,
  getLeadDropFormVariantDetails,
  getCourseVariantDetails,
  getHigherQualificationVariantDetails,
  getUniversityVariantDetails,
  // API
  upsertUniversitySettings,
} from "./universitySettings";
export type { UniversitySettingKey, UniversitySettingConfig, VariantConfig } from "./universitySettings";

